import {Box} from "@mui/system";
import {Button, CircularProgress, Typography} from "@mui/material";
import LoginTextField from "../LoginTextField/LoginTextField";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { FormEventHandler } from "react";

type UsernameBoxProps = {
    value: string
    loading: boolean
    setUsername: Function
    onClick:  FormEventHandler;
}


const formSx = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
};

const boxSx = {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'space-between'
};

const UsernameBox = ({
    value,
    loading,
    setUsername,
    onClick
}: UsernameBoxProps) => (
    <>
        <Box component="form" onSubmit={onClick} sx={formSx}>
            <Typography variant="h2" gutterBottom>
                Sign in&hellip;
            </Typography>
            <Typography variant="body1" gutterBottom>
                In order to continue, you must sign in first. Please enter your email address to continue.
            </Typography>
            <Box sx={boxSx}>
                <LoginTextField
                    id={"username"}
                    type="text"
                    label={"Email address or username:"}
                    placeholder={"user@example.com"}
                    required
                    value={value}
                    onChangeHandler={(ev: Event, value: string) => setUsername(value)}
                />
                <Button
                    id="submit-button"
                    variant="contained"
                    color="success"
                    fullWidth
                    type="submit"
                    disabled={value === '' || loading}
                    endIcon={
                        loading ?
                            <CircularProgress size={24} color={'inherit'}/> :
                            <NavigateNextIcon sx={{marginBottom: '-4px'}} />
                    }
                >
                    Continue
                </Button>
            </Box>
        </Box>

    </>
);

export default UsernameBox;
